// Charter configuration client for the ops config dashboard. GET/PUT /api/charter/config on the
// Java backend (operations role) — the SAME resolved config the Python planner reads each turn, so
// an edit here changes planner behavior + quote math with no code change. Auth pattern mirrors
// charterDispatchApi (prefer a fresh Cognito session token).
import { getCurrentSession } from '../services/authService';

const API_BASE = process.env.REACT_APP_MOVORRA_API_URL || 'http://localhost:8081';

async function authHeaders(authSession) {
  let token = authSession?.idToken;
  try { const s = await getCurrentSession(); token = s.idToken; } catch (e) { /* keep prop token */ }
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return headers;
}

async function send(path, authSession, method, body) {
  const headers = await authHeaders(authSession);
  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    let detail = `Request failed (${res.status})`;
    try { const b = await res.json(); detail = b.error || b.message || detail; } catch (e) { /* non-JSON */ }
    throw new Error(detail);
  }
  return res.json().catch(() => null);
}

// The fully-resolved config (pricing + planner + validation + service area).
export const getCharterConfig = (authSession) =>
  send('/api/charter/config', authSession, 'GET');

// Persist edits; returns the re-resolved config.
export const updateCharterConfig = (config, authSession) =>
  send('/api/charter/config', authSession, 'PUT', config);
